<template>
    <div class="p-4">
        <h2>License List Excel</h2>
        <div v-if="licenseListAllowed" class="d-flex flex-row">
            <div class="ds-text-regular mt-2 mb-2" style="width: 500px;">
                <div>
                    <el-button
                        :disabled="downloadingLicenses"
                        title="Download all licenses as xlsx-file"
                        id="test-id-download-licenses"
                        type="primary"
                        class="mt-5"
                        :loading="downloadingLicenses"
                        @click="getAllLicenses">
                        DOWNLOAD LICENSES
                    </el-button>
                </div>

            </div>
            <div class="ds-text-regular mt-2 mb-2 pr-5 pl-5" style="width: 600px;">
                <h2>Instructions</h2>
                <p>
                    Click <i>DOWNLOAD LICENSES</i> button to download an xlsx-file with all generated licenses and their information.
                </p>
            </div>
        </div>
        <div v-else>
            <p>You do not have access rights to license list.</p>
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script lang='ts'>
import { QueryAllLicenses } from '@/store/licenselist/actions';
import { ElMessage } from 'element-plus';
import * as XLSX from 'xlsx';

import { defineComponent } from 'vue';

export default defineComponent({
    name: 'LicenseList',
    data() {
        return {
            licenseListAllowed: this.$store.state.user.licenseListAllowed,
            downloadingLicenses: false,
        };
    },
    methods: {
        async getAllLicenses() {
            this.downloadingLicenses = true;
            const res = await this.$store.dispatch(new QueryAllLicenses());
            const ws = XLSX.utils.aoa_to_sheet([res.headers].concat(res.data));
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'StatusMapping');
            XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'base64'});
            XLSX.writeFile(wb, 'licenses.xlsx');
            ElMessage({
                message: 'All licenses exported',
                type: 'success',
                showClose: true,
                duration: 3000,
            });
            this.downloadingLicenses = false;
        }
    },
    computed: {
    },
    components: {
    },
});
</script>
